<template>
	<div class="eia-validated-input"
		:class="classes">
		<div>
			<eia-heading
				v-if="errorMessage"
				level="h5">
				{{ errorMessage }}
			</eia-heading>

			<eia-input
				:placeholder="placeholder"
				:type="type"
				:value="value"
				@input="onInput"
				@enter="onEnter"
				@blur="onBlur">
			</eia-input>
		</div>
	</div>
</template>

<script>
export default {
	name: 'eia-validated-input',
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		type: {
			type: String,
			default: '',
		},
		value: {
			type: [ String, Number ],
			default: '',
		},
		validators: {
			type: Array,
			required: true,
			validator( value ) {
				return value.every( d => typeof d === 'function' );
			},
		},
		showErrorIndentation: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			errorMessage: null,
			internalValue: this.value,
		};
	},

	computed: {
		classes() {
			if( this.errorMessage && this.showErrorIndentation ) {
				return 'eia-indented eia-indented--error';
			}

			if( this.errorMessage ) {
				return 'eia-validated-input--has-error';
			}

			return undefined;
		},
	},

	watch: {
		value( oldValue, newValue ) {
			if( oldValue !== newValue ) {
				this.errorMessage = null;
			}
		},
	},

	methods: {
		onInput( value ) {
			//this.errorMessage = null;
			this.internalValue = value;
			// this.$emit( 'input', value, true );
			this.onBlur( false );
		},

		onEnter() {
			this.$emit( 'enter' );
		},

		onBlur( showError = true ) {
			const errors = this.validators.reduce( ( out, validator ) => {
				const result = validator( this.internalValue );

				if( typeof result === 'string' ) {
					out.push( result );
				}

				return out;
			}, [] );

			// We only want to display the first error, so
			// just pop that one off the list. If the order of
			// validators given is from least to most important,
			// this will always display the most important, which
			// is a good thing!
			if( errors.length > 0 ) {

				if( showError ){
					this.errorMessage = errors.pop();
					this.$emit( 'error', true, this.errorMessage );
				}

				this.$emit( 'input', this.internalValue, false );
			}
			else {
				this.errorMessage = null;
				this.$emit( 'error', false, null );
				this.$emit( 'input', this.internalValue, true );
			}

			this.$emit( 'blur', errors.length === 0 );
		},
	},
};
</script>

<style lang="scss">
.eia-validated-input {
	margin: 16px 0;

	> div {
		display: flex;
		flex-direction: column;

		.eia-heading {
			color: $color-danger;
		}
	}

	&.eia-indented--error,
	&--has-error {
		input {
			border-color: $color-danger !important;
		}
	}

	&.eia-indented--error {
		margin-left: -12px;
	}
}
</style>
